/* Asynchronously write javascript, even with document.write., v1.4.0 https://krux.github.io/postscribe
 Copyright (c) 2015 Derek Brans, MIT license https://github.com/krux/postscribe/blob/master/LICENSE */!function(){function a(a,h){a=a||"",h=h||{};for(var i in b)b.hasOwnProperty(i)&&(h.autoFix&&(h["fix_"+i]=!0),h.fix=h.fix||h["fix_"+i]);var j=[],k=document.createElement("div"),l=function(a){return"string"==typeof a&&-1!==a.indexOf("&")?(k.innerHTML=a,k.textContent||k.innerText||a):a},m=function(b){a+=b},n=function(b){a=b+a},o={comment:/^<!--/,endTag:/^<\//,atomicTag:/^<\s*(script|style|noscript|iframe|textarea)[\s\/>]/i,startTag:/^</,chars:/^[^<]/},p={comment:function(){var b=a.indexOf("-->");return b>=0?{content:a.substr(4,b),length:b+3}:void 0},endTag:function(){var b=a.match(d);return b?{tagName:b[1],length:b[0].length}:void 0},atomicTag:function(){var b=p.startTag();if(b){var c=a.slice(b.length);if(c.match(new RegExp("</\\s*"+b.tagName+"\\s*>","i"))){var d=c.match(new RegExp("([\\s\\S]*?)</\\s*"+b.tagName+"\\s*>","i"));if(d)return{tagName:b.tagName,attrs:b.attrs,content:d[1],length:d[0].length+b.length}}}},startTag:function(){var b=a.indexOf(">");if(-1===b)return null;var d=a.match(c);if(d){var g={},h={},i=d[2];return d[2].replace(e,function(a,b){if(arguments[2]||arguments[3]||arguments[4]||arguments[5])if(arguments[5])g[arguments[5]]="",h[b]=!0;else{var c=arguments[2]||arguments[3]||arguments[4]||f.test(b)&&b||"";g[b]=l(c)}else g[b]=null;i=i.replace(a,"")}),{tagName:d[1],attrs:g,booleanAttrs:h,rest:i,unary:!!d[3],length:d[0].length}}},chars:function(){var b=a.indexOf("<");return{length:b>=0?b:a.length}}},q=function(){for(var b in o)if(o[b].test(a)){g&&console.log("suspected "+b);var c=p[b]();return c?(g&&console.log("parsed "+b,c),c.type=c.type||b,c.text=a.substr(0,c.length),a=a.slice(c.length),c):null}},r=function(a){for(var b;b=q();)if(a[b.type]&&a[b.type](b)===!1)return},s=function(){var b=a;return a="",b},t=function(){return a};return h.fix&&!function(){var b=/^(AREA|BASE|BASEFONT|BR|COL|FRAME|HR|IMG|INPUT|ISINDEX|LINK|META|PARAM|EMBED)$/i,c=/^(COLGROUP|DD|DT|LI|OPTIONS|P|TD|TFOOT|TH|THEAD|TR)$/i,d=[];d.last=function(){return this[this.length-1]},d.lastTagNameEq=function(a){var b=this.last();return b&&b.tagName&&b.tagName.toUpperCase()===a.toUpperCase()},d.containsTagName=function(a){for(var b,c=0;b=this[c];c++)if(b.tagName===a)return!0;return!1};var e=function(a){return a&&"startTag"===a.type&&(a.unary=b.test(a.tagName)||a.unary,a.html5Unary=!/\/>$/.test(a.text)),a},f=q,g=function(){var b=a,c=e(f());return a=b,c},i=function(){var a=d.pop();n("</"+a.tagName+">")},j={startTag:function(a){var b=a.tagName;"TR"===b.toUpperCase()&&d.lastTagNameEq("TABLE")?(n("<TBODY>"),l()):h.fix_selfClose&&c.test(b)&&d.containsTagName(b)?d.lastTagNameEq(b)?i():(n("</"+a.tagName+">"),l()):a.unary||d.push(a)},endTag:function(a){var b=d.last();b?h.fix_tagSoup&&!d.lastTagNameEq(a.tagName)?i():d.pop():h.fix_tagSoup&&k()}},k=function(){f(),l()},l=function(){var a=g();a&&j[a.type]&&j[a.type](a)};q=function(){return l(),e(f())}}(),{append:m,readToken:q,readTokens:r,clear:s,rest:t,stack:j}}var b=function(){var a,b={},c=this.document.createElement("div");return a="<P><I></P></I>",c.innerHTML=a,b.tagSoup=c.innerHTML!==a,c.innerHTML="<P><i><P></P></i></P>",b.selfClose=2===c.childNodes.length,b}(),c=/^<([\-A-Za-z0-9_]+)((?:\s+[\w\-]+(?:\s*=?\s*(?:(?:"[^"]*")|(?:'[^']*')|[^>\s]+))?)*)\s*(\/?)>/,d=/^<\/([\-A-Za-z0-9_]+)[^>]*>/,e=/(?:([\-A-Za-z0-9_]+)\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|([^>\s]+)))|(?:([\-A-Za-z0-9_]+)(\s|$)+)/g,f=/^(checked|compact|declare|defer|disabled|ismap|multiple|nohref|noresize|noshade|nowrap|readonly|selected)$/i,g=!1;a.supports=b,a.tokenToString=function(a){var b={comment:function(a){return"<!--"+a.content},endTag:function(a){return"</"+a.tagName+">"},atomicTag:function(a){return g&&console.log(a),b.startTag(a)+a.content+b.endTag(a)},startTag:function(a){var b="<"+a.tagName;for(var c in a.attrs){b+=" "+c;var d=a.attrs[c];("undefined"==typeof a.booleanAttrs||"undefined"==typeof a.booleanAttrs[c])&&(b+='="'+(d?d.replace(/(^|[^\\])"/g,'$1\\"'):"")+'"')}return a.rest&&(b+=a.rest),b+(a.unary&&!a.html5Unary?"/>":">")},chars:function(a){return a.text}};return b[a.type](a)},a.escapeAttributes=function(a){var b={};for(var c in a){var d=a[c];b[c]=d&&d.replace(/(^|[^\\])"/g,'$1\\"')}return b};for(var h in b)a.browserHasFlaw=a.browserHasFlaw||!b[h]&&h;this.htmlParser=a}(),function(){function a(){}function b(a){return a!==m&&null!==a}function c(a){return"function"==typeof a}function d(a,b,c){var d,e=a&&a.length||0;for(d=0;e>d;d++)b.call(c,a[d],d)}function e(a,b,c){var d;for(d in a)a.hasOwnProperty(d)&&b.call(c,d,a[d])}function f(a,b){return e(b,function(b,c){a[b]=c}),a}function g(a,c){return a=a||{},e(c,function(c,d){b(a[c])||(a[c]=d)}),a}function h(a){try{return o.call(a)}catch(b){var c=[];return d(a,function(a){c.push(a)}),c}}function i(a){return a&&"tagName"in a?!!~a.tagName.toLowerCase().indexOf("script"):!1}function j(a){return a&&"tagName"in a?!!~a.tagName.toLowerCase().indexOf("style"):!1}var k={afterAsync:a,afterDequeue:a,afterStreamStart:a,afterWrite:a,autoFix:!0,beforeEnqueue:a,beforeWriteToken:function(a){return a},beforeWrite:function(a){return a},done:a,error:function(a){throw a},releaseAsync:!1},l=this,m=void 0;if(!l.postscribe){var n=!1,o=Array.prototype.slice,p=function(a){return a[a.length-1]},q=function(){function a(a,c,d){var e=k+c;if(2===arguments.length){var f=a.getAttribute(e);return b(f)?String(f):f}b(d)&&""!==d?a.setAttribute(e,d):a.removeAttribute(e)}function g(b,c){var d=b.ownerDocument;f(this,{root:b,options:c,win:d.defaultView||d.parentWindow,doc:d,parser:htmlParser("",{autoFix:c.autoFix}),actuals:[b],proxyHistory:"",proxyRoot:d.createElement(b.nodeName),scriptStack:[],writeQueue:[]}),a(this.proxyRoot,"proxyof",0)}var k="data-ps-";return g.prototype.write=function(){[].push.apply(this.writeQueue,arguments);for(var a;!this.deferredRemote&&this.writeQueue.length;)a=this.writeQueue.shift(),c(a)?this.callFunction(a):this.writeImpl(a)},g.prototype.callFunction=function(a){var b={type:"function",value:a.name||a.toString()};this.onScriptStart(b),a.call(this.win,this.doc),this.onScriptDone(b)},g.prototype.writeImpl=function(a){this.parser.append(a);for(var b,c,d,e=[];(b=this.parser.readToken())&&!(c=i(b))&&!(d=j(b));)b=this.options.beforeWriteToken(b),b&&e.push(b);this.writeStaticTokens(e),c&&this.handleScriptToken(b),d&&this.handleStyleToken(b)},g.prototype.writeStaticTokens=function(a){var b=this.buildChunk(a);if(b.actual)return b.html=this.proxyHistory+b.actual,this.proxyHistory+=b.proxy,this.proxyRoot.innerHTML=b.html,n&&(b.proxyInnerHTML=this.proxyRoot.innerHTML),this.walkChunk(),n&&(b.actualInnerHTML=this.root.innerHTML),b},g.prototype.buildChunk=function(a){var b=this.actuals.length,c=[],e=[],f=[];return d(a,function(a){var d=htmlParser.tokenToString(a);if(c.push(d),a.attrs){if(!/^noscript$/i.test(a.tagName)){var g=b++;e.push(d.replace(/(\/?>)/," "+k+"id="+g+" $1")),"ps-script"!==a.attrs.id&&"ps-style"!==a.attrs.id&&f.push("atomicTag"===a.type?"":"<"+a.tagName+" "+k+"proxyof="+g+(a.unary?" />":">"))}}else e.push(d),f.push("endTag"===a.type?d:"")}),{tokens:a,raw:c.join(""),actual:e.join(""),proxy:f.join("")}},g.prototype.walkChunk=function(){for(var c,d=[this.proxyRoot];b(c=d.shift());){var e=1===c.nodeType,f=e&&a(c,"proxyof");if(!f){e&&(this.actuals[a(c,"id")]=c,a(c,"id",null));var g=c.parentNode&&a(c.parentNode,"proxyof");g&&this.actuals[g].appendChild(c)}d.unshift.apply(d,h(c.childNodes))}},g.prototype.handleScriptToken=function(a){var b=this.parser.clear();if(b&&this.writeQueue.unshift(b),a.src=a.attrs.src||a.attrs.SRC,a=this.options.beforeWriteToken(a)){a.src&&this.scriptStack.length?this.deferredRemote=a:this.onScriptStart(a);var c=this;this.writeScriptToken(a,function(){c.onScriptDone(a)})}},g.prototype.handleStyleToken=function(a){var b=this.parser.clear();b&&this.writeQueue.unshift(b),a.type=a.attrs.type||a.attrs.TYPE||"text/css",a=this.options.beforeWriteToken(a),a&&this.writeStyleToken(a),b&&this.write()},g.prototype.writeStyleToken=function(a){var b=this.buildStyle(a);this.insertStyle(b),a.content&&(b.styleSheet&&!b.sheet?b.styleSheet.cssText=a.content:b.appendChild(this.doc.createTextNode(a.content)))},g.prototype.buildStyle=function(a){var b=this.doc.createElement(a.tagName);return b.setAttribute("type",a.type),e(a.attrs,function(a,c){b.setAttribute(a,c)}),b},g.prototype.insertStyle=function(a){this.writeImpl('<span id="ps-style"/>');var b=this.doc.getElementById("ps-style");b.parentNode.replaceChild(a,b)},g.prototype.onScriptStart=function(a){a.outerWrites=this.writeQueue,this.writeQueue=[],this.scriptStack.unshift(a)},g.prototype.onScriptDone=function(a){return a!==this.scriptStack[0]?void this.options.error({message:"Bad script nesting or script finished twice"}):(this.scriptStack.shift(),this.write.apply(this,a.outerWrites),void(!this.scriptStack.length&&this.deferredRemote&&(this.onScriptStart(this.deferredRemote),this.deferredRemote=null)))},g.prototype.writeScriptToken=function(a,b){var c=this.buildScript(a),d=this.shouldRelease(c),e=this.options.afterAsync;a.src&&(c.src=a.src,this.scriptLoadHandler(c,d?e:function(){b(),e()}));try{this.insertScript(c),(!a.src||d)&&b()}catch(f){this.options.error(f),b()}},g.prototype.buildScript=function(a){var b=this.doc.createElement(a.tagName);return e(a.attrs,function(a,c){b.setAttribute(a,c)}),a.content&&(b.text=a.content),b},g.prototype.insertScript=function(a){this.writeImpl('<span id="ps-script"/>');var b=this.doc.getElementById("ps-script");b.parentNode.replaceChild(a,b)},g.prototype.scriptLoadHandler=function(a,b){function c(){a=a.onload=a.onreadystatechange=a.onerror=null}function d(){c(),b()}function e(a){c(),g(a),b()}var g=this.options.error;f(a,{onload:function(){d()},onreadystatechange:function(){/^(loaded|complete)$/.test(a.readyState)&&d()},onerror:function(){e({message:"remote script failed "+a.src})}})},g.prototype.shouldRelease=function(a){var b=/^script$/i.test(a.nodeName);return!b||!!(this.options.releaseAsync&&a.src&&a.hasAttribute("async"))},g}();l.postscribe=function(){function b(){var a,b=j.shift();b&&(a=p(b),a.afterDequeue(),b.stream=d.apply(null,b),a.afterStreamStart())}function d(c,d,g){function j(a){a=g.beforeWrite(a),m.write(a),g.afterWrite(a)}m=new q(c,g),m.id=i++,m.name=g.name||m.id,e.streams[m.name]=m;var k=c.ownerDocument,l={close:k.close,open:k.open,write:k.write,writeln:k.writeln};f(k,{close:a,open:a,write:function(){return j(h(arguments).join(""))},writeln:function(){return j(h(arguments).join("")+"\n")}});var n=m.win.onerror||a;return m.win.onerror=function(a,b,c){g.error({msg:a+" - "+b+":"+c}),n.apply(m.win,arguments)},m.write(d,function(){f(k,l),m.win.onerror=n,g.done(),m=null,b()}),m}function e(d,e,f){c(f)&&(f={done:f}),f=g(f,k),d=/^#/.test(d)?l.document.getElementById(d.substr(1)):d.jquery?d[0]:d;var h=[d,e,f];return d.postscribe={cancel:function(){h.stream?h.stream.abort():h[1]=a}},f.beforeEnqueue(h),j.push(h),m||b(),d.postscribe}var i=0,j=[],m=null;return f(e,{streams:{},queue:j,WriteStream:q})}()}}();

if ( $('.flip-container').length ) {
    function resizeFlip() {
        $('.flip-container').each(function () {
            var $flip = $(this);
            var frontHeight = $flip.find('.front').height();
            var backHeight  = $flip.find('.back').height();

            if (frontHeight > backHeight) {
                $flip.find('.back').height(frontHeight);
            } else {
                $flip.find('.front').height(backHeight);
            }
        });
    }

    $(window).on('resize', function() {
        resizeFlip();
    });

    $('.flip-container').click(function() {
      console.log(1);
      $(this).toggleClass('hover');
    });
}

var isTouchDevice = 'ontouchstart' in document.documentElement;
if( !isTouchDevice ) {
  $('body').addClass('no-touch');
}

//Force Clear localStorage to avid any issues
if(typeof(Storage) !== "undefined") {
  if (!localStorage.getItem("local-storage-cleared-v2")) {
    localStorage.clear();
    localStorage.setItem("local-storage-cleared-v2", true);
  }
}

var enablePollReVote = true;

var lazyAdContent = null;

function changeFileLinks() {
  $('a[href*="/file/"]').each(function () {
    $(this).addClass('is-file-downloading').attr('target','_blank');
  });
}

function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}
function detectDevice() {
  if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    if (screen.width > 767) {
      return 'tablet';
    } else {
      return 'mobile';
    }
  } else {
    return 'desktop';
  }
}

var ad_block_was_detected = false;
/*
// Function called if AdBlock is not detected
function adBlockNotDetected() {
  console.log('AdBlock is not enabled');
}
// Function called if AdBlock is detected
function adBlockDetected() {
  console.log('AdBlock is enabled');
//  ga('send', 'event', 'adBlock', 'pageview'); it was moved to defer.js
  ad_block_was_detected = true;

  var startTime = localStorage.getItem('adblock_start_time');
  var currentTime = parseInt((new Date().getTime()) / 1000);
  if (!startTime) {
    startTime = currentTime;
    localStorage.setItem('adblock_start_time', startTime);
  }

  var lessHourOfWork = true;
  if (currentTime - startTime > 60 * 60) {
    lessHourOfWork = false;
  }

  if (AD_BLOCK_ON) {
    if (lessHourOfWork) {
      if (AD_BLOCK_WHITELIST) {
        var adBlockWhitelist = AD_BLOCK_WHITELIST.split(';');
        if (adBlockWhitelist.indexOf(window.location.pathname) != -1) {
          return false;
        }
      }
      if (AD_BLOCK_VEIWPORTS) {
        var adBlockViewports = AD_BLOCK_VEIWPORTS.split(';');
        if (adBlockViewports.indexOf(detectDevice()) == -1) {
          return false;
        }
      }
    }

    var numPage = localStorage.getItem('adblock_page_history');

    if (!numPage) {
      localStorage.setItem('adblock_page_history', 1);
      numPage = 1;
    }

    if (numPage == AD_BLOCK_NUM_PAGES || (!AD_BLOCK_LIMIT_PER_SESSION && numPage > AD_BLOCK_NUM_PAGES)) {
      $('#adblock_modal').modal('show');

      if (!AD_BLOCK_LIMIT_PER_SESSION) {
        localStorage.setItem('adblock_page_history', 1);
      } else {
        localStorage.setItem('adblock_page_history', ++numPage);
      }
    } else {
      localStorage.setItem('adblock_page_history', ++numPage);
    }
  }
}

// Recommended audit because AdBlock lock the file 'fuckadblock.js'
// If the file is not called, the variable does not exist 'fuckAdBlock'
// This means that AdBlock is present
if(typeof fuckAdBlock === 'undefined') {
  adBlockDetected();
} else {
  fuckAdBlock.onDetected(adBlockDetected);
  fuckAdBlock.onNotDetected(adBlockNotDetected);
}

// Change the options
fuckAdBlock.setOption('checkOnLoad', true);
*/
$(window).on('load', function() {
  if ($(window).width() <= 767) {
    var logo = $('.container .logo'),
        logoImg = logo.find('.img-logo'),
        paddingImg = Math.max(5, ((46 - logoImg.height()) / 2 ));

    logoImg.css('padding-top', paddingImg);
    logoImg.css('padding-bottom', paddingImg);
    logoImg.css('width', 'auto');
    logoImg.css('margin', '0 auto');
    logoImg.css('opacity', '1');
  }
});

var lazyAdWasInit = false;
var screenWidth = $(window).width();

//function initAdv() {
//  postscribe('#ad_top', '<script type="text/javascript">loadAd(header_auid);</script>');
//  postscribe('#ad-middle-container', '<script type="text/javascript">loadAd(mid_auid);</script>');
//}

var slot1, slot2, slot3;

$(document).ready(function(){
  changeFileLinks();

  var b = document.documentElement;
  b.setAttribute('data-useragent',  navigator.userAgent);
  b.setAttribute('data-platform', navigator.platform );

  $('#lazy-page').val(1);

  var homeLazyEnabled = true;
  var $homeLazyPage = $('#lazy-page');
  var additionalParams = '';

  $(document).on('scroll', function () {

    var minDiff = 600,
        scrollPosition = $(document).scrollTop(),
        windowHeight = $(window).height(),
        mainHeight = $('.content').height(),
        uri = window.location.pathname.split('/category/'),
        dividedPath = uri[0].split('/');
        isEvents = dividedPath.length > 1 && dividedPath[1] == 'events';
        urlLazy = '/lazy/articles',
        containerId = '#articles-lazy-container';

        console.log(uri[0], uri[0].indexOf( "/author/" ) >= 0);

    switch (uri[0]) {
      case "/":
        urlLazy = '/lazy/articles';
        break;
      case "/bloggers":
        urlLazy = '/lazy/bloggers';
        containerId = '#lazy-container';
        additionalParams = '&filter=' + $('#sel2').val() + '&sort=' + $('#sel3').val();
        break;
      case "/authors":
        urlLazy = '/lazy/authors';
        containerId = '#lazy-container';
        additionalParams = '&filter=' + $('#sel2').val() + '&sort=' + $('#sel3').val();
        break;
      case "/videos":
        urlLazy = '/lazy/videos';
        containerId = '#lazy-container';
        additionalParams = '&sort=' + $('#video-sort').val() + '&search=' + $('#video-search').val()
        break;
      case "/blogs":
        urlLazy = '/lazy/blogs';
        containerId = '#lazy-container';
        break;
      case "/magazines":
        urlLazy = '/lazy/magazines';
        containerId = '#lazy-container';
        additionalParams = '&year=' + $('#magazines-year').val();
        break;
      case "/polls":
        urlLazy = '/lazy/polls';
        containerId = '#lazy-container';
        break;
      case "/surveys":
        urlLazy = '/lazy/surveys';
        containerId = '#lazy-container-surveys';
        break;
      case "/jobs":
        urlLazy = '/lazy/jobs';
        containerId = '#lazy-jobs';
        break;
      case "/slideshows":
        urlLazy = '/lazy/slideshows';
        containerId = '#lazy-slideshows';
        break;
    }

    if (isEvents) {
      urlLazy = '/lazy/events/' + $('#month').val();
    }

    // for blog posts - page {site}/author/{slug}
    if (uri[0].indexOf( "/blogger/" ) >= 0 || uri[0].indexOf( "/author/" ) >= 0) {
      urlLazy = '/lazy' + uri[0];
      additionalParams = '&sort=' + $('[data-id="bloggerposts-sort"]').val();
      containerId = '#lazy-container-blog-posts';
    }

    if (uri[0].indexOf( "/comments" ) >= 0) {
      urlLazy = '/lazy' + uri[0];
      containerId = '#lazy-container';
    }

    if (uri[0].indexOf( "/tag" ) >= 0) {
      urlLazy = '/lazy' + uri[0];
      containerId = '#lazy-container';
    }

    if (uri[1]) {
      urlLazy = '/lazy/category/' + uri[1];
      containerId = '#lazy-container';
    }

    if (mainHeight - scrollPosition - windowHeight < minDiff && homeLazyEnabled
      && (uri[0] == "/" || uri[0] == "/bloggers" || uri[0] == "/authors" || uri[0] == "/polls" || uri[0] == "/surveys" || uri[0] == "/videos" || uri[0] == "/magazines"  || uri[0] == "/blogs" || uri[0] == "/jobs" || uri[0] == "/slideshows" || ((uri[0].indexOf( "/blogger/") >= 0 || uri[0].indexOf( "/author/") >= 0) || uri[1])
      || (uri[0].indexOf( "/comments" ) >= 0) || (uri[0].indexOf( "/tag") >= 0 ) || isEvents ) ) {
      homeLazyEnabled = false;

      var url = urlLazy + '?page=' + $homeLazyPage.val() + additionalParams;

      var currentPage = $homeLazyPage.val();

      var loadMoreContent = function() {
        $('.spinner').show();
        $.ajax({
          url: (urlLazy.indexOf('/events') >= 0) ? urlLazy + '?page=' + $homeLazyPage.val() : url,
          type: "GET",
          dataType: "html",
          statusCode: {
            200: function() {
              homeLazyEnabled = true;
            },
            204: function() {
              $('.spinner').hide();
            },
            404: function() {
              $('.spinner').hide();
            }
          },
          success: function(content) {
            if (isEvents) {
              containerId = '#lazy-container';
            }
            $('.spinner').hide();
            $(containerId).append(content);

            if (google_ad_ID) {

                  slot1 = googletag.pubads().display('/'+google_ad_ID+'/' + lazy_auid_1, [[728, 90], [300, 250], [320, 50], [300, 50], [320, 100]],
                         'gpt-ad-lazy-'+currentPage+'_1');
                  slot2 = googletag.pubads().display('/'+google_ad_ID+'/' + lazy_auid_2, [[320, 50], [320, 100], [300, 50], [300, 250], [728, 90]],
                         'gpt-ad-lazy-'+currentPage+'_2');
                  slot3 = googletag.pubads().display('/'+google_ad_ID+'/' + lazy_auid_3, [[728, 90], [300, 250], [300, 50], [320, 100], [320, 50]],
                        'gpt-ad-lazy-'+currentPage+'_3');

            }

            setTimeout(function(){ fixIframeAdv() }, 1500);

            $homeLazyPage.val( parseInt($homeLazyPage.val()) + 1 );

            listenExistingImages();
          }
        });
      }
      loadMoreContent();

      console.log('Lazy Load page num: ' + currentPage);

      //if (currentPage > 1 && lazyAdContent) {
      //  loadMoreContent();
      //}
    }

  });

  $(document).on('click', '.is-file-downloading', function () {
    var href = $(this).attr('href');
    var fileSlug = href.substr(href.lastIndexOf('/') + 1);

    ga('send', 'event', 'File Download', fileSlug);

    if ('undefined' !== gtagId && 0 !== gtagId.length) {
      gtag('event', fileSlug, {
        'event_category': 'File Download',
      })
    }
  });

  $('#post-static-newsletter-button').click(function() {
    var that = $(this).closest('.static-page-form'),
        email = that.find('[name="email"]');

    that.parent().find('[role="alert-success"]').hide();
    that.parent().find('[role="alert-newsletter"]').hide();
    that.parent().find('[role="alert-custom"]').hide();
    that.parent().find('[role="alert-confirm"]').hide();

    if (email.hasClass('error')) {
      that.parent().find('[role="alert"]').hide();
      email.removeClass('error');
    }

    if (validateEmail(email.val())) {
      if (email.val() == $('[name="emailconfirm"]').val()) {
          if (that.attr('data-newsletter-id') != 6 && $(".static-page-form .newsletter-options:checked").length == 0) {
            that.parent().find('[role="alert-newsletter"]').show();
            $("html, body").animate({ scrollTop: 0 }, 200);
          } else {
            $('#post-static-newsletter-button').attr('disabled','disabled');
            $('#post-static-newsletter-button').text('SUBMITTING...');

            $.post('/newsletter/send/' + that.attr('data-newsletter-id'), that.serialize(), function(data) {
              $('#post-static-newsletter-button').removeAttr('disabled');
              $('#post-static-newsletter-button').text('Subscribe to the selected newsletters');
              grecaptcha.reset();

              if (data.err) {
                that.parent().find('[role="alert-custom"]').show();
                that.parent().find('[role="alert-custom"]').html(data.err);
              } else {
                that.parent().find('[role="alert-success"]').show();
              }

              $("html, body").animate({ scrollTop: 0 }, 200);
            }, 'json');
          }
      } else {
          that.parent().find('[role="alert-confirm"]').show();
          $("html, body").animate({ scrollTop: 0 }, 200);
      }
    } else {
      that.parent().find('[role="alert"]').show();
      email.addClass('error');
      $("html, body").animate({ scrollTop: 0 }, 200);
    }

    return false;
  });

  if(typeof(Storage) !== "undefined") {
    var storageWorks = true;
  } else {
    var storageWorks = false;
  }

  var pollSubmitInProgress = false;
  // poll widget
  $('body').on('click', '.poll_btn', function() {
    if (pollSubmitInProgress) {
        return false;
    }

    pollSubmitInProgress = true;
    var that = $(this).parent().parent();
    var pollId = that.closest('.poll-id').data('poll-id');

    $.post('/poll/vote', that.serialize(), function(data) {

      if (data.err) {
        that.parent().find('[data-attr="pollText"]').hide();
        that.parent().find('[data-attr="pollNoResult"]').show();

        if (!enablePollReVote) {
          localStorage.setItem("isVoted-" + pollId, true);
        }
      } else if (data[0]) {
        var html = '<div class="graph-wrapper">';

        for (var i = 0; i < data[0]['options'].length; i++) {
          html += '<p class="label-answer">' + data[0]['options'][i]['name'] + '</p><div class="bar-container"><p>' + data[1][data[0]['options'][i]['id']]['percent'] + '% </p> <div class="bar-wrapper"><div class="bar" style="width:' + data[1][data[0]['options'][i]['id']]['percent'] + '%;"></div></div></div>';
        }
        html += '</div>';

        that.parent().find('.pollResultsTemplate').html(html);
        that.parent().find('.pollResultsTemplate').show();

        if (!enablePollReVote) {
          localStorage.setItem("isVoted-" + pollId, data[2]['option_id']);
        }
        localStorage.setItem("isVotedCount-" + pollId, data[1][data[2]['option_id']]['count']);
      }

      if (enablePollReVote) {
        that.parent().find('.re-vote-btn').show();
      }
      that.remove();

      $('#poll_page_success').show();
      $('#thankPollMessage').hide();
      pollSubmitInProgress = false;
    }, 'json');
  });

  /**
   * Vertically center Bootstrap 3 modals so they aren't always stuck at the top
   */
  $(function() {
    function reposition() {
      var modal = $(this),
        dialog = modal.find('.modal-dialog');
      modal.css('display', 'block');

      // Dividing by two centers the modal exactly, but dividing by three
      // or four works better for larger screens.
        var margin_top = Math.max(0, ($(window).height() - dialog.height()) / 2);
        if (margin_top < 30) margin_top = 30;
      dialog.css("margin-top", margin_top);
    }

    // Reposition when a modal is shown
    $('.modal-share').on('show.bs.modal', reposition);
    $('.modal-adv-main').on('show.bs.modal', reposition);
    $('.modal-newsletter-main').on('show.bs.modal', reposition);
    $('.modal-personal-main').on('show.bs.modal', reposition);

    // Reposition when the window is resized
    $(window).on('resize', function() {
      $('.modal-share:visible').each(reposition);
      $('.modal-adv-main:visible').each(reposition);
      $('.modal-newsletter-main:visible').each(reposition);
      $('.modal-personal-main:visible').each(reposition);
    });
  });

  $(function() {
    if ($('.header.header-scroll .logo').length) {
      var logo = $('.header.header-scroll .logo'),
          logoImg = logo.find('img'),
          paddingImg = Math.max(0, ((54 - logoImg.height()) / 2 )),
          navBar = logo.find('.navbar-brand');

      navBar.css('padding-top', paddingImg);
      navBar.css('padding-bottom', paddingImg);
    }
  });

  $(function() {
    if ($('.header.header-scroll .logo').length) {
      var logo = $('.header.header-scroll .logo'),
        logoImg = logo.find('img'),
        paddingImg = Math.max(0, ((54 - logoImg.height()) / 2 )),
        navBar = logo.find('.navbar-brand');

      navBar.css('padding-top', paddingImg);
      navBar.css('padding-bottom', paddingImg);
    }

    if ($(window).width() <= 767) {
      var windowMenu = $(window).height();
      var menuHeight = $('.nav.nav-stacked').height();
      var heigthLastViewPart = menuHeight % windowMenu;
      var creditInfo = $('.credits-mobile');

      if (heigthLastViewPart === 0) {
        creditInfo.css('margin-top', windowMenu - heigthLastViewPart - 100 - 20);
      } else {
        creditInfo.css('margin-top', 40);
      }

      //var logo = $('.container .logo'),
      //    logoImg = logo.find('.img-logo'),
      //    paddingImg = Math.max(5, ((46 - logoImg.height()) / 2 ));
      //
      //logoImg.css('padding-top', paddingImg);
      //logoImg.css('padding-bottom', paddingImg);
      //logoImg.css('width', 'auto');
      //logoImg.css('margin', '0 auto');
    }

  });

  var windowHeight = $(window).height();

  $(window).resize(function() {
    if ($(window).width() <= 767) {
      var windowMenu = $(window).height();
      var menuHeight = $('.nav.nav-stacked').height();
      var heigthLastViewPart = menuHeight % windowMenu;
      var creditInfo = $('.credits-mobile');

      if (heigthLastViewPart === 0) {
        creditInfo.css('margin-top', windowMenu - heigthLastViewPart - 100 - 20);
      } else {
        creditInfo.css('margin-top', 40);
      }

      if ($(window).height() != windowHeight) {
        $('body').removeClass('menu-active');
        $('#navbar-menu-link').addClass('nav-menu-closed');
        $('.remove-menu').hide();
      }

      if ($(window).width() != screenWidth) {
        var ua = navigator.userAgent;

        var logo = $('.container .logo'),
          logoImg = logo.find('.img-logo'),
          paddingImg = Math.max(5, ((46 - logoImg.height()) / 2 ));

        if (ua.search(/Safari/) > 0) {
          paddingImg -= 2;
        }

        logoImg.css('padding-top', paddingImg);
        logoImg.css('padding-bottom', paddingImg);
        logoImg.css('width', 'auto');
        logoImg.css('margin', '0 auto');
        logoImg.css('opacity', '1');
      }
    }

    if ($(window).width() > 767) {
      var logo = $('.container .logo'),
          logoImg = logo.find('img');

      logoImg.css('padding-top', 0);
      logoImg.css('padding-bottom', 0);

    }
  });

if ($('#thumbnailUrl').length > 0) {

    $('#thumbnailUrl').uploadifive({
        'fileTypeDesc': 'Image Files',
        'fileTypeExts': '*.gif; *.jpg; *.jpeg; *.png; *.bmp;',
        'debug': 'false',
        'auto': 'true',
        'method': 'post',
        'width': 80,
        'fileSizeLimit': '5MB',
        'onUploadError': function (file, errorCode, errorMsg, errorString) {
            alert('The file ' + file.name + ' could not be sent. There was the following error: ' + errorString + ' Message: ' + errorMsg + ' code: ' + errorCode + ' File: ' + file);
        },
        'onError': function (err, file) {
            if (err == 'FILE_SIZE_LIMIT_EXCEEDED') {
               alert(file.name + ' - is too large to upload. Limit is ' + (parseInt($('#maxFileSize').val()) / 1024 / 1024) + 'MB');
            }
        },
        'onUpload': function () {
            $('.uploadifive-queue').show();
        },
        'onUploadComplete': function (file, data) {
            $('.uploadifive-queue').hide();
            var data = $.parseJSON(data);
            if (data && typeof data === "object" && data !== null) {
                if (data.error) {
                    alert(data.error, data.err_title ? data.err_title : 'Error');
                } else if (data.success) {
                    $('#thumbnail').val(data.filename);
                    $('#thumbnail').attr('readonly', 'readonly');
                    $('#thumbnailNew').val(data.url);
                    //$('#imgPreviewDiv').show();
                    $('#imgPreviewDiv').removeClass('hidden');
                    $('#imgPreview').attr('src',data.url);
                }
            }
        },
        'uploadScript': "uploadifive",
        formData: {'_token': globalToken}
    });

    $(document).on('click', '#thumbnail', function () {
        $('#uploadifive-thumbnailUrl input[type=file]').last().click();
    });

    $(document).on('click', '.open-uploadify', function () {
        var targetButtonId = $(this).data('uploadify-id');
        $('#' + targetButtonId + ' input[type=file]').last().click();
    });
}

  //$(".main-sub.col img").on('load', function() {
  //  if ($('.main-sub.col').length) {
  //    var contentBlockHeight = parseInt($('.main-sub.col').height());
  //    $('.main-big.col.border-right').find('.post.block').height(contentBlockHeight);
  //  }
  //});

});

$(function() {
  if ($('.scroll-wrapper-widget').length) {
    if(navigator.userAgent.match(/iPad|iPhone/i)) {
      $('.scroll-wrapper-widget').each(function(){
        $(this).addClass('ios-widget');

        var height = $(this).find('.height-widget').val();
        $(this).css('max-height', height + 'px');
        $(this).css('margin-bottom', '40px');
      });


    }
  }
});

$(document).ready(function() {

  // if ($('body').hasClass('ad-billboard-fixed')) {
  //   var initRemove = false;
  //   $(window).scroll(function() {
  //     if ($('body').hasClass('ad-billboard-fixed') && !initRemove) {
  //       initRemove = true;
  //       setTimeout(function() {
  //         $('body').removeClass('ad-billboard-fixed')
  //       }, 5000);
  //     }
  //   });
  // }
  if ($('body').hasClass('ad-top-fixed')) {
    var initRemove = false;
    $(window).scroll(function() {
      if ($(window).scrollTop() > 100) {
        $('.ad-top').addClass('ad-top-trick-scroll');
      } else {
        $('.ad-top').removeClass('ad-top-trick-scroll');
      }
      if ($('body').hasClass('ad-top-fixed') && !initRemove) {
        initRemove = true;
        setTimeout(function() {
          $('body').removeClass('ad-top-fixed')
        }, 5000);
      }
    });
  }

  $(function() {
    if ($('.img-featured').length) {
      setTimeout(function(){
        $('.img-featured').removeClass('wrapper-featured-img');
      }, 1000);
    }
  });

  $('.social-header-link').click(function (){
    $(this).blur();
  });

  var fixEventInfoElementsHeight = function(){
    var labelDetail = $('.label-detail a');
    if (labelDetail.height() > 20) {
      labelDetail.parent().css('height', labelDetail.height()+25 + 'px');
      $('.label-info').last().css('height', labelDetail.height()+25 + 'px');
    }
    $('.label-detail > span').each(function () {
      if ($(this).height() > 20) {
        $(this).parent().css('height', labelDetail.height()+25 + 'px');
        $(this).parent().prev().css('height', labelDetail.height()+25 + 'px');
      }
    });
  };

  if ($('.event-info').length) {
    fixEventInfoElementsHeight();
    $(window).resize(function(){
      fixEventInfoElementsHeight();
    });
  }
});

// comment characters counter
$(document).ready(function() {
  $(function() {
    if ($('#Comments').length) {
      var limit = 500;

      $('#Comments').keyup(function(e) {
        var count = limit - $(this).val().length;

        $('#characters-counter').text(count);
      });
    }
  });
});

function checkProceedCheckoutButton() {
  var count = $('.catalog-feature-item.selected').length;

  if ( count ) {
    $('.checkout-proceed-button-count').html(count);
    $('.checkout-proceed-button').removeClass('hidden');
  } else {
    $('.checkout-proceed-button').addClass('hidden');
  }

  var products = [];

  $('.catalog-feature-item.selected').each(function (index) {
    products[index] = { 'productId' : $(this).data('product-id'), 'typeId' : $(this).data('type-id') };
  });

  localStorage.setItem('pd_products', JSON.stringify(products));
  localStorage.setItem('pd_catalog_id', $('#catalog-id-input').val());
}

$(document).on('click', '.checkout-proceed-button-text', function () {
  if ( getPDToken() ) {
    showProvidersModal(JSON.parse(localStorage.getItem('pd_products')));
  } else {
    localStorage.setItem('checkout_proceed', 1);
    window.location.href = "/login";
  }
});

$(document).ready(function(){
  var targetImageHeight = $('.slide-show-slide-item').length ? 398 : 338;
console.log('qwe', targetImageHeight);
  $(function(){
    if ($('.img-full-with-bg').length) {
      $('.img-featured .img-full-with-bg img').on('load', function(){
        var bgFeaturedImg = $('.img-full-with-bg').height();
        var heightFeaturedImg = $('.img-featured-height').val();
        var widthFeaturedImg = $('.img-featured-width').val();

        if (heightFeaturedImg <= targetImageHeight) {
          $('.img-featured .main-featured-img').css('top', Math.max(0, (bgFeaturedImg - heightFeaturedImg) / 2));
        }

      });
    }
  });

  $(function(){
    if ($('.img-full-with-bg').length) {
      var bgFeaturedImg = $('.img-full-with-bg').height();
      var heightFeaturedImg = $('.img-featured-height').val();
      var widthFeaturedImg = $('.img-featured-width').val();

      if (heightFeaturedImg <= targetImageHeight) {
        $('.img-featured .main-featured-img').css('top', Math.max(0, (bgFeaturedImg - heightFeaturedImg) / 2));
      }

    }
  });

  function resizeFeaturedSmallImage() {
    if ($('.img-full-with-bg').length) {
      var bgFeaturedImg = $('.img-full-with-bg').height();
      var heightFeaturedImg = $('.img-featured-height').val();
      var widthFeaturedImg = $('.img-featured-width').val();

      if (heightFeaturedImg <= targetImageHeight) {
        $('.img-featured .main-featured-img').css('top', Math.max(0, (bgFeaturedImg - heightFeaturedImg) / 2));
      }

      if (bgFeaturedImg <= heightFeaturedImg) {
        $('.img-featured .main-featured-img').css('height', bgFeaturedImg + 'px');
        if (!bgFeaturedImg) {
          setTimeout(function() {
            resizeFeaturedSmallImage();
          }, 500);
        }
      } else {
        $('.img-featured .main-featured-img').css('height', heightFeaturedImg + 'px');
        if (!heightFeaturedImg) {
          setTimeout(function() {
            resizeFeaturedSmallImage();
          }, 500);
        }
      }
    }
  }

  resizeFeaturedSmallImage();
  $(window).resize(function(){
    resizeFeaturedSmallImage();
    setMobileTopAddMargin();
  });

  function setMobileTopAddMargin() {
    if ($(window).width() < 768) {
      var topAdHeight = $('#ad_top > div').height();
      var loadedAdFlag = $('#ad_top > div').attr('data-google-query-id');
      if (topAdHeight) {
        if (topAdHeight == 50 && loadedAdFlag && loadedAdFlag.length) {
          $('.ad-top-fixed').addClass('ad-top-mobile-50');
          if (setIntervalMobileTopAddMargin) clearInterval(setIntervalMobileTopAddMargin);
        } else if (topAdHeight == 90 && loadedAdFlag && loadedAdFlag.length) {
          $('.ad-top-fixed').addClass('ad-top-mobile-90');
          if (setIntervalMobileTopAddMargin) clearInterval(setIntervalMobileTopAddMargin);
        } else if (topAdHeight == 250 && loadedAdFlag && loadedAdFlag.length) {
          $('.ad-top-fixed').removeClass('ad-top-mobile-50');
          $('.ad-top-fixed').removeClass('ad-top-mobile-90');
          if (setIntervalMobileTopAddMargin) clearInterval(setIntervalMobileTopAddMargin);
        } else {
          $('.ad-top-fixed').removeClass('ad-top-mobile-50');
          $('.ad-top-fixed').removeClass('ad-top-mobile-90');
        }
      }
    }
  }

  var setIntervalMobileTopAddMarginSteps = 0;
  var setIntervalMobileTopAddMargin = setInterval(function() {
    setMobileTopAddMargin();
    setIntervalMobileTopAddMarginSteps++;
    if (setIntervalMobileTopAddMarginSteps > 40) {
      clearInterval(setIntervalMobileTopAddMargin);
    }
  }, 500);

  $('#comment-form').on('submit', function(e) {
    e.preventDefault();
    document.getElementById('post-comment-button').disabled = true;

    var data = $('#comment-form').serialize();

    $.post($('#comment-form').attr('action'), data, function(res) {
      document.getElementById('post-comment-button').disabled = false;
      console.log(res);

      if (res.failed) {
        $('.alert-success').hide();

        var errorsMessage = 'Please fill out all required information*<br>';

        for (var key in res.errors) {
          var fieldErrors = res.errors[key];
          fieldErrors.forEach(function(error){
            errorsMessage += error + '<br>';
          });
        }

        $('.alert-danger').html(errorsMessage);
        $('.alert-danger').show();
      } else {
        $('.alert-danger').hide();
        $('.alert-success').html(res.message);
        $('.alert-success').show();

        $('#Name').val('');
        $('#email').val('');
        $('#Location').val('');
        $('#Comments').val('');
        document.getElementById("agree-terms").checked = false;
      }

      grecaptcha.reset();

      $('html, body').animate({
        scrollTop: $("h1.h1").offset().top - 100
      }, 500);
    });
  });

  $('#event-form').on('submit', function(e) {
    e.preventDefault();
    document.getElementById('post-event-button').disabled = true;

    var data = $('#event-form').serialize();

    $.post($('#event-form').attr('action'), data, function(res) {
      document.getElementById('post-event-button').disabled = false;
      console.log(res);

      if (res.failed) {
        $('.alert-success').hide();

        var errorsMessage = 'Please fill out all required information*<br>';

        for (var key in res.errors) {
          var fieldErrors = res.errors[key];
          fieldErrors.forEach(function(error){
            errorsMessage += error + '<br>';
          });
        }

        $('.alert-danger').html(errorsMessage);
        $('.alert-danger').show();
      } else {
        $('.alert-danger').hide();
        $('.alert-success').html(res.message);
        $('.alert-success').show();

        $('#firstname').val('');
        $('#lastname').val('');
        $('#phone').val('');
        $('#eventtitle').val('');
        $('#short_description').val('');
        $('#description').val('');
        $('#location').val('');
        $('#venue').val('');
        $('#url').val('');
        $('#imgPreviewDiv').addClass('hidden');
        $('#thumbnail').val('');
        $('#start-date input').val('');
        $('#end-date input').val('');
      }

      grecaptcha.reset();
      $('html, body').animate({
        scrollTop: $("h1.h1").offset().top - 100
      }, 500);
    });
  });
  
  $('.catalog-feature-item').on('click', function (e) {
    if ( !$(this).hasClass('individual') ) {
      e.preventDefault();
      $(this).toggleClass('selected');
      checkProceedCheckoutButton();
    }
  });
  
});

$(document).on('click', '.re-vote-btn', function(e) {
  e.preventDefault();

  var pollId = $(this).data('target');
  var pollHref = $(this).attr('href');

  if (enablePollReVote) {
    localStorage.removeItem("isVoted-" + pollId);
  }

  window.location.href = pollHref;
  location.href = pollHref;
});

function getPDToken() {
  var token = localStorage.getItem('pd_token');
  var now = new Date().getTime();

  if (token != null) {
    var tokenObject = JSON.parse(token);
    var setupTime = tokenObject.setupTime;

    if(now - setupTime > tokenObject.coef * 60 * 60 * 1000) {
      localStorage.removeItem("pd_token");
      localStorage.removeItem("pd_provider_uuid");
      localStorage.removeItem("pd_products");
      localStorage.removeItem("pd_catalog_id");
      localStorage.removeItem("checkout_proceed");
      return null;
    }

    return tokenObject.value;
  }

  return null;
}

$(document).ready(function(){
    if (localStorage.getItem("was_logged_out")) {
        $("#login-timeout-done").modal();
        localStorage.removeItem("was_logged_out");
    }

    // autocomplete search in Directory
    if ($('#search-text-widget').length) {
        var interval = setInterval(function() {
            if (typeof google != 'undefined') {
                clearInterval(interval);

                var city = (document.getElementById('search-text-widget'));
                var city_autocomplete = new google.maps.places.Autocomplete(city, {language: 'en', types: ['(regions)']});
                city_autocomplete.addListener('place_changed', function ()
                {
                    var vicinity = city_autocomplete.getPlace().formatted_address;
                    if (vicinity) {
                        city.value = vicinity;
                    }
                });
            }
        }, 200);
    }
});

// all time in seconds
var authTimeout = 60 * 60; // 1 hour
var authWarning = 60 * 5; // 5 mins
var authLiveCheckTime = 60;
var forceLogoutInterval = null;
var forceLogoutTimeTickerInterval = null;

function initTimeTickerInterval() {
    var timeLeft = authWarning;
    forceLogoutTimeTickerInterval = setInterval(function(){
        if (timeLeft >= 0) {
            timeLeft--;
            var timeLeftText = '';

            if (timeLeft >= 60) {
                var minutes = parseInt(timeLeft/60);
                var seconds = parseInt(timeLeft%60);
                if (seconds == 0) {
                    seconds = '00';
                } else if (seconds < 10) {
                    seconds = '0' + seconds;
                }
                timeLeftText = minutes + ':' + seconds + ' minutes';
            } else {
                if (timeLeft == 1) {
                    timeLeftText = '1 second';
                } else {
                    timeLeftText = timeLeft + ' seconds';
                }
            }

            $('#login-timeout-warning-time').html(timeLeftText);
        }
    }, 1000);
}

function pageReload() {
    forcePageReload = true;
    var path = window.location.pathname;
    var restrictedPaths = ['/account','/directory/checkout/register','/directory/checkout','/directory/register', '/directory/register/truncated'];
    if (restrictedPaths.indexOf(path) != -1) {
        window.location.href = '/';
    } else {
        window.location.reload();
    }
}

function updateActivity() {
    console.log('updating Activity...');
    localStorage.setItem("auth_activity", Math.floor(Date.now() / 1000));
}

function updateActivityAndInterval() {
    clearInterval(forceLogoutInterval);
    clearInterval(forceLogoutTimeTickerInterval);
    updateActivity();
    initActivityInterval();
}

function initActivityInterval() {
    var authLiveCheckInterval = setInterval(function() {
        if (authLiveCheckIntervalOver()) {
            clearInterval(authLiveCheckInterval);

            forceLogoutInterval = setInterval(function(){
                fullLogOut();
                localStorage.setItem("was_logged_out", true);
                pageReload();
            }, authWarning * 1000);
        }
    }, authLiveCheckTime * 1000);
}

function isTimeout() {
    var now = Math.floor(Date.now() / 1000);
    var lastActivity = localStorage.getItem("auth_activity");
    var timeDiff = now - lastActivity;

    console.log('ACTIVITY WAS AGO ', timeDiff);

    if (timeDiff > authTimeout) {
        return true;
    } else {
        return false;
    }
}

function authLiveCheckIntervalOver() {
    if ( isTimeout() ) {
        initTimeTickerInterval();
        setTimeout(function() {
            $("#login-timeout-warning").modal({
                backdrop: 'static',
                keyboard: false
            });
        }, 500);
        return true;
    } else {
        return false;
    }
}

function checkLoginTimeout() {
    console.log('LOGGED IN !');
    var remember = localStorage.getItem("auth_remember");

    if (!remember) {
        if ( isTimeout() ) {
            fullLogOut();
            if (forceLogOutRequired) {
                window.location.href = "/";
            }
            return false;
        } else {
            initActivityInterval();
            updateActivity();
            return true;
        }
    } else {
        return true;
    }
}

function checkLoginUser() {
  if (localStorage.getItem('pd_token') != null && checkLoginTimeout()) {
    $('body').addClass('disable-head-transition');
    $('body').addClass('is-logged');
    $('#logged-bar').removeClass('hidden');
    $('.directory-login-register-block').addClass('hidden');
  } else {
    console.log('NOT LOGGED');
    $('body').addClass('disable-head-transition');
    $('body').removeClass('is-logged');
    $('#logged-bar').addClass('hidden');
    $('.directory-login-register-block').removeClass('hidden');
  }

  setTimeout(function() {
      $('body').removeClass('disable-head-transition');
  }, 1000);
}

$(document).on('submit', 'form.dir-forgot-form', function (e) {
    e.preventDefault();
    return false;
});
$(document).on('click', '.smt-dir-forgot-form', function (e) {
  e.preventDefault();

  $('input#email').val( $.trim($('input#email').val()) );

  var url = '/forgot';

  $.ajax({
    type: "POST",
    url: url,
    data: $('form.dir-forgot-form').serialize(),
    dataType: "json",
    success: function(data)
    {
      if (data.hasOwnProperty('success')) {
        $( '.errors-block' ).addClass('hidden');
        $( '.success-block' ).removeClass('hidden');
        localStorage.setItem("pd_token", JSON.stringify(objectToken));
        updateActivity();
      } else if (data.hasOwnProperty('error')) {
        $( '.success-block' ).addClass('hidden');
        $( '.errors-block' ).html( 'Please fill out all required information *' + '<br>' + data.error );
        $( '.errors-block' ).removeClass('hidden');
      }
    },
    error: function(data){
      $( '.errors-block' ).removeClass('hidden');
      $( '.success-block' ).addClass('hidden');
    }
  });
});

$(document).on('click', '.smt-dir-reset-form', function (e) {
  e.preventDefault();

  var url = '/reset';

  $.ajax({
    type: "POST",
    url: url,
    data: $('form.dir-reset-form').serialize(),
    dataType: "json",
    success: function(data)
    {
      if (data.hasOwnProperty('token')) {
        $( '.errors-block' ).addClass('hidden');
        $( '.success-block' ).removeClass('hidden');

        var objectToken;

        if (data.remember) {
          objectToken = {value: data.token, setupTime : new Date().getTime(), coef : 336};
        } else {
          objectToken = {value: data.token, setupTime : new Date().getTime(), coef : 120};
        }

        localStorage.setItem("pd_token", JSON.stringify(objectToken));
        updateActivity();
      } else if (data.hasOwnProperty('error')) {
        console.log('here');

        $( '.errors-block' ).html( 'Please fill out all required information *' + '<br>' + data.error );
        $( '.errors-block' ).removeClass('hidden');
        $( '.success-block' ).addClass('hidden');
      }

      checkLoginUser();
    },
    error: function(data){
      if( data.status === 422 ) {
        errors = data.responseJSON;

        errorsText = 'Please fill out all required information *';

        $.each( errors, function( key, value ) {
          $('form.dir-login-form #' + key).addClass('with-error');
          errorsText += '<br>' + value[0] + ''; //showing only the first error.
        });

        $( '.errors-block' ).html( errorsText );
        $( '.errors-block' ).removeClass('hidden');
      }
    }
  });
});

function showProvidersModal() {

  $.ajax({
    type: "POST",
    url: "/directory/api/providers/search",
    data: { pdToken: getPDToken() },
    success: function (response) {
      if (response.hasOwnProperty('providers')) {
        var providers = response.providers;

        if ( providers.length > 1 ) {
          var html = '<ul class="list-group">';

          providers.forEach(function(item) {
            html += '<li class="list-group-item"><div class="radio"><label>' +
              '<input class="custom-input provider-checkbox" type="radio" value="' + item.uuid + '" name="provider">' +
              item.text + ', ' + item.main_location +
              '</label></div></li>';
          });

          html += '</ul>';

          $('#provides_modal .providers-wrapper').html(html);

          $('#provides_modal .custom-input').iCheck({
            checkboxClass: 'icheckbox',
            radioClass: 'iradio',
            increaseArea: '20%'
          });

          $('#provides_modal').modal('show');
        } else if ( providers.length == 1 ) {
          localStorage.setItem('pd_provider_uuid', providers[0].uuid);
          window.location.href = '/directory/checkout';
        } else {
          localStorage.setItem('checkout_proceed', 1);
          window.location.href = "/directory/checkout/register";
        }

      } else {
        console.log(response);
      }
    },
    error: function (response) {
      console.log(response);
    }
  });


}

$(document).on('click', '.continue_order', function (e) {
  e.preventDefault();

  localStorage.removeItem('pd_provider_uuid');

  var providerId = $('.iradio.checked .provider-checkbox').val();

  if (typeof providerId != 'undefined') {
    localStorage.setItem('pd_provider_uuid', providerId);
    window.location.href = '/directory/checkout';
  }
});

function postClaimProviderProcess(uuid) {
    postData('/directory/api/claim', {provider: uuid}, function(res) {
        console.log(res);

        if (res.error && res.error == 'auth') {
            window.location.href = '/login';
        } else if (res) {
            window.location.href = '/account#/provider/' + uuid;
        } else {
            $('#already-claimed').modal();
        }
    });
}

$(document).on('click', '.close-claimed-modal', function () {
    var href = location.href;
    var uri = href.match(/([^\/]*)\/*$/)[1];

    console.log(uri);

    if ( (uri == 'register') || (uri == 'login') || (uri == 'login#') ) {
        window.location.href = '/directory';
    }
});

$(document).on('click', '.smt-dir-login-form', function (e) {
    e.preventDefault();

    $('input#email').val( $.trim($('input#email').val()) );

    var url = '/login';
    var formData = $('form.dir-login-form').serialize();

    console.log(formData);

    $.ajax({
        type: "POST",
        url: url,
        data: formData,
        success: function(data)
        {
        if (data.hasOwnProperty('token')) {
            $( '.errors-block' ).addClass('hidden');
            $('form.dir-login-form #email').removeClass('hidden');
            $('form.dir-login-form #password').removeClass('hidden');

            var objectToken;

            if (data.remember) {
                localStorage.setItem("auth_remember", true);
                objectToken = {value: data.token, setupTime : new Date().getTime(), coef : 336};
            } else {
                objectToken = {value: data.token, setupTime : new Date().getTime(), coef : 120};
            }

            localStorage.setItem("pd_token", JSON.stringify(objectToken));
            updateActivity();

            var products = localStorage.getItem('pd_products');

            if ( products ) {
            showProvidersModal();
            return;
            }

            var providerUUID = localStorage.getItem('claim_provider_uuid');

            if (providerUUID) {
                console.log('postClaimProviderProcess');
                console.log(providerUUID);

                localStorage.removeItem('claim_provider_uuid');
                postClaimProviderProcess(providerUUID);

                return false;
            }

            window.location.href = "/account";
        } else if (data.hasOwnProperty('error')) {
            var textError = data.hasOwnProperty('credit') ? data.error : 'Please fill out all required information *' + '<br>' + data.error;

            $( '.errors-block' ).html(textError);
            $( '.errors-block' ).removeClass('hidden');
        }

        checkLoginUser();
    },
    error: function(data){
      localStorage.removeItem("pd_token");

      if( data.status === 422 ) {
        errors = data.responseJSON;

        errorsText = 'Please fill out all required information *';

        $.each( errors, function( key, value ) {
          $('form.dir-login-form #' + key).addClass('with-error');
          errorsText += '<br>' + value[0] + ''; //showing only the first error.
        });

        $( '.errors-block' ).html( errorsText );
        $( '.errors-block' ).removeClass('hidden');
      }

      checkLoginUser();
    }
  });
});

function fullLogOut() {
    localStorage.removeItem("pd_token");
    localStorage.removeItem("auth_activity");
    localStorage.removeItem("auth_remember");
    localStorage.removeItem("pd_token");
    localStorage.removeItem("pd_provider_uuid");
    localStorage.removeItem("pd_products");
    localStorage.removeItem("pd_catalog_id");
    localStorage.removeItem("checkout_proceed");
}

$(document).on('click', '.logout-link', function (e) {
  e.preventDefault();

  fullLogOut();
    
  window.location.href = $(this).data('redirect');
});

$(document).ready(function () {
    checkLoginUser();

    if ($('.singleSelect-item').length) {
        $('.singleSelect-item').multipleSelect({
            single: true
        });

        // RSS widget snippet
        if ($('.rss-widget-config').length) {
            $('.rss-widget-config').on('change', function() {
                var rssTarget = $('#rss-target').val();
                var rssHeadline = $('#rss-headlines').val();
                var rssHeight = $('#rss-height').val();

                var siteTitle = $('#input-link-rss').data('site-title');
                var siteUrl = $('#input-link-rss').data('site-url');

                if (rssTarget) {
                    var snippet = '<!-- '+siteTitle+' RSS Widget --><style> ';
                    snippet += '#smartandstrong-rss-widget {position:relative;padding-bottom:'+rssHeight+'px;height:0;overflow:hidden;} ';
                    snippet += '#smartandstrong-rss-widget iframe {position:absolute;top:0;left:0;width:100%;height:100%;} ';
                    snippet += '</style> <div id="smartandstrong-rss-widget"></div> ';
                    snippet += '<script src="'+siteUrl+'/rss-widget.js?t='+rssTarget+'&c='+rssHeadline+'&h='+rssHeight+'"></script>';
                    snippet += '<!-- END of '+siteTitle+' RSS Widget -->';

                    $('#input-link-rss').val(snippet);

                    $('#snippet-copy-wrapper').css('visibility','visible');
                }
            })
        }
    }

    if ($('.dropdown-has-groups').length) {
        setTimeout(function() {
            $('.form-group.dropdown').each(function() {
                var $dropdown = $(this);
                var hasGroup = false;
                $dropdown.find('li').each(function() {
                    var $option = $(this);
                    if ($option.hasClass('group')) {
                        hasGroup = true;
                        $option.append('<div class="collapse-group"></div>');
                    } else if (hasGroup) {
                        $option.addClass('inside-group');
                    }
                });
            });

            $('.form-group.dropdown .collapse-group').click(function(){
                var group = $(this).parent().children('.optgroup').data('group');

                if ($(this).hasClass('closed')) {
                    $(this).removeClass('closed');
                    $(this).closest('ul').find('.inside-group input').each(function(){
                        if ($(this).data('group') == group) {
                            $(this).closest('li').show();
                        }
                    });
                } else {
                    $(this).addClass('closed');
                    $(this).closest('ul').find('.inside-group input').each(function(){
                        if ($(this).data('group') == group) {
                            $(this).closest('li').hide();
                        }
                    });
                }
            });

            setTimeout(function() {
                $('.form-group.dropdown .collapse-group').each(function() {
                    $(this).click();
                });
            }, 100);
        }, 200);
    }
});

String.prototype.highlightAll = function(search) {
    var target = this;
    return target.replace(new RegExp('(\\b'+search+'\\b)(?!([^<]+)?>)', 'gi'), '<span class="search-found">$1</span>');
};

$(document).ready(function() {
    var hash = window.location.hash;
    var $h1 = $('.content-block h1').length ? $('.content-block h1') : ($('.head-page.no-gutter.clearfix h1.article-title').length ? $('.head-page.no-gutter.clearfix h1.article-title') : $('.article-title.categories-title.top-position') );
    var $body = $('.content-block .post-content');

    if (hash && hash.match(/search\-query/i)) {
        var stopWords = ['&', '', 'I', 'a', 'about', 'an', 'are', 'as', 'at', 'be', 'by', 'com', 'for', 'from', 'how', 'in', 'is', 'it', 'of', 'on', 'or', 'that', 'the', 'this', 'to', 'was', 'what', 'when', 'where', 'who', 'will', 'with', 'the', 'www'];

        var query = hash.split('=')[1].split('%20');

        query.forEach(function(word) {
            word = word.replace('"', '').replace('"', '').replace('%22', '').replace('%22', '');
            if (stopWords.indexOf(word) == -1) {
                word = word.replace('.', '');
                if ($h1 && $h1.length) {
                    $h1.html( $h1.html().highlightAll(word) );
                }
                if ($body && $body.length) {
                    $body.html( $body.html().highlightAll(word) );
                }
            }
        });
    }
});

$(document).ready(function() {
  initAllPolls();

    if ($('.custom-search').length) {
      $('#search-range-filter').daterangepicker({
        autoUpdateInput: false
      });

      $('#search-range-filter').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY'));
      });

      $('#clear-date-range').click(function(e) {
        e.preventDefault();
        $('input[name=d]').val("");
        var resultsText = $('.results-found').html();
        resultsText = resultsText.split(' | ');
        $('.results-found').html(resultsText[0]);

        $('#custom-search-form').submit();
      });

      $('#default-search').change(function() {
        $('#advanced-search').val($('#default-search').val());
      });
      $('#advanced-search').change(function() {
        $('#default-search').val($('#advanced-search').val());
      });
    }
});

function initAllPolls() {
  $('.poll-id').each(function() {
    var $that = $(this);
    var pollId = $that.closest('.poll-id').data('poll-id');

    if(typeof(Storage) !== "undefined") {
      var isVoted = localStorage.getItem("isVoted-" + pollId);
      var isVotedCount = parseInt( localStorage.getItem("isVotedCount-" + pollId) );
      console.log('Poll:', pollId, 'voted', isVoted, 'count', isVotedCount);

      if (isVoted) {
        $that.find('.poll-form-template-' + pollId).hide();

        if (enablePollReVote) {
          $that.find('.re-vote-btn').show();
        }

        if ($that.find('.poll-results-template-' + pollId).length) {
          $that.find('.poll-results-template-' + pollId).show();
          $that.find('.poll-text-template-' + pollId).show();

          if (isVotedCount) {
            var currentResult = JSON.parse( $that.find('.poll-results-' + pollId).val() );

            // console.log('Current Result', currentResult);

            if (currentResult[isVoted]['count'] < isVotedCount) {
              // console.warn('!!! Cache was not updated yet !!!');

              currentResult[isVoted]['count'] = isVotedCount;
              var totalCount = 0;

              for (var key in currentResult) {
                // console.log(currentResult[key]);
                totalCount += currentResult[key]['count'];
              }

              // console.log('TOTAL', totalCount);

              for (var key in currentResult) {
                var updatedPercent = Math.round((currentResult[key]['count'] / totalCount) * 100);
                // console.log('Updated', updatedPercent);

                $that.find('.poll-results-percent-' + pollId + '-' + key).html(updatedPercent + '%');
                $that.find('.poll-results-bar-' + pollId + '-' + key).css('width', updatedPercent + '%');
              }

            }
          }
        } else {
          $that.find('.poll-no-results-template-' + pollId).show();
        }

      } else {
        $that.find('.poll-text-template-' + pollId).show();
        $that.find('.poll-form-template-' + pollId).show();
      }
    } else {
      $that.find('.poll-text-template-' + pollId).show();
      $that.find('.poll-form-template-' + pollId).show();
    }
  });

  $('.custom-input').iCheck({
    checkboxClass: 'icheckbox',
    radioClass: 'iradio',
    increaseArea: '20%' // optional
  });
}

function initNewsletterPopUps() {
  setTimeout(function() {
    $('input[name^="mailchimpModalKeys"]').each(function() {
      var key = $(this).val();
      grecaptcha.render('newsletter_mailchimp_captcha_' + key, {
        'sitekey' : $('#newsletter_mailchimp_captcha_' + key).data('sitekey')
      });

      $("#newsletter_mailchimp_" + key).on('shown.bs.modal', function() {
        $('.visible-form').addClass('invisible-form');
        $('.modal-spinner').show();

        $.get('/mailchimp-tags', function(formFields) {
          $("#newsletter_mailchimp_" + key).find('.mailchimp-tags').html(formFields);

          setTimeout(function() {
            var resizeEvent = new Event('resize');
            window.dispatchEvent(resizeEvent);

            $('.modal-spinner').hide();
            $('.invisible-form').removeClass('invisible-form');
          }, 10);
        });
      });
    });

    // newsletter widget
    $('[name*="all"]').click(function() {
      var timeId = $(this).attr('data-attr');

      if ($(this).is(":checked")) {
        $('[data-attr="site_' + timeId + '"]').prop('checked', true);
      }
    });

    $('[data-attr*="site_"]').click(function() {
      var arrayTimeId = $(this).attr('data-attr').split('_');

      if (!$(this).is(":checked")) {
        $('[data-attr="' + arrayTimeId[1] + '"]').prop('checked', false);
      }
    });

    $('.pozpersonal_btn').click(function() {
      var that = $(this).parent().parent(),
          id = that.find('[name*="id"]');
      pass = that.find('[name*="password"]');

      if (id.hasClass('error')) {
        that.parent().find('[role="alert"]').hide();
        id.removeClass('error');
      }
      if (pass.hasClass('error')) {
        that.parent().find('[role="alert"]').hide();
        pass.removeClass('error');
      }

      if (id.val() && pass.val()) {
        $('#' + that.find('#pozpersonalBoxId').val()).modal('hide');
        that.submit();
      } else {
        if (!id.val()) {
          that.parent().find('[role="alert"]').show();
          id.addClass('error');
        }
        if (!pass.val()) {
          that.parent().find('[role="alert"]').show();
          pass.addClass('error');
        }
      }

      return false;
    });

    $('.newsletter_btn').removeAttr('disabled');
    $('.newsletter_btn').text('SUBMIT');
    $('.newsletter_btn').click(function() {
      var that = $(this).parent().parent(),
          email = that.find('[name*="email"]');

      that.parent().find('[role="alert-success"]').hide();
      that.parent().find('[role="alert-newsletter"]').hide();
      that.parent().find('[role="alert-custom"]').hide();
      if (email.hasClass('error')) {
        that.parent().find('[role="alert"]').hide();
        email.removeClass('error');
      }

      if (validateEmail(email.val())) {
        if($(".newsletter-options:checked").length == 0) {
          that.parent().find('[role="alert-newsletter"]').show();
        } else {
          $('.newsletter_btn').attr('disabled','disabled');
          $('.newsletter_btn').text('SUBMITTING...');

          $.post('/newsletter/send', that.serialize(), function(data) {
            $('.newsletter_btn').removeAttr('disabled');
            $('.newsletter_btn').text('SUBMIT');
            grecaptcha.reset();

            if (data.err) {
              that.parent().find('[role="alert-custom"]').show();
              that.parent().find('[role="alert-custom"]').html(data.err);
            } else {
              that.parent().find('[role="alert-success"]').show();
            }
          }, 'json');
        }
      } else {
        that.parent().find('[role="alert"]').show();
        email.addClass('error');
      }

      $('.modal-newsletter-main').scrollTop(0);

      if ($('#newsletter-page').length) {
        $('body, html').scrollTop(0);
      }

      return false;
    });
  }, 500);
}

var config = {
  rootMargin: '0px 0px 50px 0px',
  threshold: 0
};
var observer = null;

function preloadImage(target) {
  var $container = $(target);
  var $image = $(target).find('img');

  var imgUrl = $image.data('src');
  var downloadingImage = new Image();

  downloadingImage.onload = function() {
    $image.attr('src', $image.data('src'));
    setTimeout(function() {
      $image.css('opacity', 1);
      $container.removeClass('img-preload-container');
      $container.attr('style', '');
    }, 50);
  };

  downloadingImage.src = imgUrl;
}

function listenExistingImages() {
  var imgs = document.querySelectorAll('.img-preload-container');
  imgs.forEach(function(img) {
    observer.observe(img);
  });
}

function loadExistingImages() {
  var imgs = document.querySelectorAll('.img-preload-container');
  imgs.forEach(function(img) {
    preloadImage(img);
  });
}

function initDeferLoadImages() {

  if ('IntersectionObserver' in window) {
    try {
      observer = new IntersectionObserver(function(entries, self) {
        entries.forEach(function(entry) {
        if(entry.isIntersecting) {

          preloadImage(entry.target);

          self.unobserve(entry.target);
        }
      });
      }, config);

      listenExistingImages();
    } catch(err) {
      console.error('Custom Error in initDeferLoadImages:', err);
      setTimeout(function() {
        loadExistingImages();
      }, 1000);
    }
  } else {
    console.warn("IntersectionObserver not supported");
    setTimeout(function() {
      loadExistingImages();
    }, 1000);
  }
}

$(document).ready(function() {
  /* IMAGES LAZY LOAD */
  initDeferLoadImages();

  /* SIDEBAR LAZY LOAD */
  if ($(window).width() >= 1024 ) {
    loadSidebar();
  }
});

var sidebarLoaded = false;

$(window).on('resize', function() {
  if ($(window).width() >= 1024 ) {
    loadSidebar();
  }
});

function loadSidebar() {
  if (!sidebarLoaded) {
    $.get('/get-sidebar', { sidebarKey: sidebarKey, rand: Math.random() * 10001 }, function(data) {
      $('#sidebar-container').html(data);

      initNewsletterPopUps();
      initAllPolls();
    });

    sidebarLoaded = true;
  }
}

$(document).ready(function() {
  console.log("window.location.pathname", window.location.pathname);
  if ($(window).width() < 1024 && (window.location.pathname == "/newsletter" || window.location.pathname == "newsletter")) {
    loadSidebar();
  }
});
// $(document).ready(function() {
//   if ($('.social-button .fb-like').length) {
//     var fbInterval = setInterval(function() {
//       console.log(1);
//       if ($('.fb_iframe_widget.fb-like iframe').length) {
//         console.log(11111);
//
//         // var head = $(".fb_iframe_widget.fb-like iframe").contents().find("head");
//         // var css = '<style type="text/css">' +
//         //     '.uiGrid .hCent {text-align: left}; ' +
//         //     '</style>';
//         // $(head).append(css);
//
//         clearInterval(fbInterval);
//       }
//     }, 2000);
//   }
//   // $('.fb_iframe_widget.fb-like iframe').find('.hCent').style['text-align'] = 'left';
// });
